import React, { useContext } from "react";
import TemplatesWrapper from "./SUBcomponents/Scenes/templatesWrapper";
import TextWrapper from "./SUBcomponents/textWrapper";
import BackgroundsWrapper from "./SUBcomponents/backgroundWrap";
import SoundWrapper from "./SUBcomponents/soundWrapper";
import Wmark from "../../Watermark/wmark";
import ImagesWrapper from "./SUBcomponents/images/imagesWrapper";
import VideosWrapper from "./SUBcomponents/videos/Videoswrap";
import AssetsWrapper from "./SUBcomponents/Assets/assetsWrapper";
import ShapesWrapper from "./SUBcomponents/Shapes/ShapesWrapper";
import MyContext from "../../context/MyContext";
import { loadAnimation } from "lottie-web";
import { Tooltip } from "react-tippy";
import { defineLordIconElement } from "lord-icon-element";
import AuthContext from "../../context/userAuth.context";
import { useTransition, animated } from "react-spring";
import SettingsMenu from "../middle.screen.parent.component/settingsMenu";
import Swal from "sweetalert2";
// register lottie and define custom element

export const LeftSubMenu = (props) => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    setTTSData,
    editableObject,
    seteditableObject,
  } = useContext(MyContext);

  const transition = useTransition(LeftPanelActive, {
    from: { y: 50, opacity: 0 },
    enter: { y: 0, opacity: 1 },
    leave: {},
  });

  const { apiBaseurl, Access, getLink } = useContext(AuthContext);
  defineLordIconElement(loadAnimation);

  var leftMenuContent = [
    {
      id: 1,
      text: "Scene",
      className: "leftMenuItems",
      materialIcon: "color_lens",
      activeClass: "active",
    },
    {
      id: 2,
      text: "Background",
      className: "leftMenuItems",
      materialIcon: "texture",
      activeClass: "",
    },
    {
      id: 3,
      text: "Text",
      className: "leftMenuItems",
      materialIcon: "text_format",
      activeClass: "",
    },
    {
      id: 4,
      text: "Assets",
      className: "leftMenuItems2",
      activeClass: "",
    },
    {
      id: 5,
      text: "Sound",
      className: "leftMenuItems",
      materialIcon: "audiotrack",
      activeClass: "",
    },
    {
      id: 6,
      text: "Images",
      className: "leftMenuItems",
      materialIcon: "insert_photo",
      activeClass: "",
    },
    {
      id: 7,
      text: "Videos",
      className: "leftMenuItems",
      materialIcon: "video_library",
      activeClass: "",
    },
    {
      id: 8,
      text: "Uploads",
      className: "leftMenuItems",
      materialIcon: "folder",
      activeClass: "",
    },
  ];

  var leftMenuContentIconBottom = [
    {
      id: 1,
      text: "Help",
      className: "leftBottomMenu",
      materialIcon: "help",
      bottom: "56px",
    },
    {
      id: 2,
      text: "Training",
      className: "leftBottomMenu",
      materialIcon: "movie",
      bottom: "6px",
    },
  ];

  return (
    <div id="leftManuInsider" className="leftManuInsider">
      <div className="leftMenuContent  style-2">
        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Scene" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Scene");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/template.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/template_hover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Scenes</label>
        </div>

        <div
          className={
            "leftMenuItems" +
            (LeftPanelActive === "Background" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Background");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/background.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/background_hover.svg"
            alt=""
          />

          <label className={"animatedIconText"}>Backgrounds</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Text" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Text");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/text.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/text_hover.svg"
            alt=""
          />

          <label className={"animatedIconText "}>Text</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Assets" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Assets");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/character.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/character_hover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Characters</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Shapes" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Shapes");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/assets.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/assets_hover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Shapes</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Sound" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Sound");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/music.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/music_hover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Sounds</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Images" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Images");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/image.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/image_hover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Images</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Videos" ? " active" : "")
          }
          onClick={() => {
            setLeftPanelActive("Videos");
            //leftPanelHide
            seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/video.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/video_hover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Videos</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "AI" ? " active" : "")
          }
          onClick={() => {
            //setLeftPanelActive("AI");
            //leftPanelHide
            props.setAIContentPopup(true);
            //seteditableObject({ showPanel: false, editableItem: [] });
          }}
        >
          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/AiContent-01.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/AiContentHover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>AI Content</label>
        </div>

        <div
          className={
            "leftMenuItems" + (LeftPanelActive === "Watermark" ? " active" : "")
          }
          onClick={() => {
            if (Access !== "FE" && Access !== "US1") {
              setLeftPanelActive("Watermark");
              //leftPanelHide
              seteditableObject({ showPanel: false, editableItem: [] });
            }
            if (Access === "FE" || Access === "US1") {
              Swal.fire({
                title: "Upgrade Required",
                html: `You have not purchased this upgrade yet. Please <a href=${getLink(
                  true
                )} target='_blank'>upgrade</a> to unlock all features.`,
                icon: "info",
                cancelButtonColor: "#d33",
                backdrop: null,
              });
            }
          }}
        >
          {Access == "FE" && (
            <img
              className="iconUS"
              src="../AppIcons/IconsAll/PremiumIcon.svg"
              alt=""
            />
          )}

          <div className="selectedBorder"></div>
          <img
            className="newIconsImgNormal"
            src="../AppIcons/IconsAll/WaterMark.svg"
            alt=""
          />
          <img
            className="newIconsImgColor"
            src="../AppIcons/IconsAll/WaterMarkhover.svg"
            alt=""
          />
          <label className={"animatedIconText "}>Watermark</label>
        </div>
        <div>
          <hr></hr>
          <div
            className={"leftMenuItems"}
            onClick={() => {
              window.open("https://toons.ai/support/", "_blank");
            }}
          >
            <div className="selectedBorder"></div>
            <img
              className="newIconsImgNormal"
              src="../AppIcons/IconsAll/help.svg"
              alt=""
            />
            <img
              className="newIconsImgColor"
              src="../AppIcons/IconsAll/help_hover.svg"
              alt=""
            />
            <label className={"animatedIconText "}>Help</label>
          </div>
          <div
            className={"leftMenuItems"}
            onClick={() => {
              window.open("https://toons.ai/tutorials/", "_blank");
            }}
          >
            <div className="selectedBorder"></div>
            <img
              className="newIconsImgNormal"
              src="../AppIcons/IconsAll/training.svg"
              alt=""
            />
            <img
              className="newIconsImgColor"
              src="../AppIcons/IconsAll/training_hover.svg"
              alt=""
            />
            <label className={"animatedIconText "}>Training</label>
          </div>
        </div>

        {/* {leftMenuContentIconBottom.map((lmc) => (
          <div
            key={lmc.id}
            className={lmc.className}
            style={{ bottom: lmc.bottom }}
          >
            <div className="leftMenuItems">
              <div className="leftMenuIcon">
                <Tooltip
                  title="Coming Soon"
                  position="left-end"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                >
                  {" "}
                  <span className="material-icons">{lmc.materialIcon}</span>
                </Tooltip>
              </div>
              <div className="leftMenuText">{lmc.text}</div>
            </div>
          </div>
        ))} */}
      </div>

      <div className="editorpanelWrapper" id="leftEditorPanel">
        <section className="editorpanelInsider">
          <div className="editorpanelTamplateWrapper">
            <div className="editorpanelTamplate">
              <div className="editorpanelTamplateInsider">
                {/* {LeftPanelActive === "Scene" && (
                  <TemplatesWrapper key={"Menu1"} />
                )} */}

                {transition(
                  (style, item) =>
                    item === "Scene" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <TemplatesWrapper key={"Menu1"} />
                      </animated.div>
                    )
                )}

                {transition(
                  (style, item) =>
                    item === "Background" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <BackgroundsWrapper key={"Menu2"} />
                      </animated.div>
                    )
                )}
                {LeftPanelActive === "Assets" && (
                  <AssetsWrapper
                    key={"Menu3"}
                    setChrPopData={props.setChrPopData}
                    setchrPop={props.setchrPop}
                    IsTTSShow={IsTTSShow}
                    setIsTTSShow={setIsTTSShow}
                    TTSData={TTSData}
                    setTTSData={setTTSData}
                  />
                )}

                {transition(
                  (style, item) =>
                    item === "Shapes" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <ShapesWrapper key={"Menu8"} />
                      </animated.div>
                    )
                )}

                {transition(
                  (style, item) =>
                    item === "Text" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <TextWrapper key={"Menu4"} />
                      </animated.div>
                    )
                )}

                {transition(
                  (style, item) =>
                    item === "Watermark" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <Wmark key={"Menu8"} />
                      </animated.div>
                    )
                )}

                {transition(
                  (style, item) =>
                    item === "Sound" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <SoundWrapper key={"Menu5"} />
                      </animated.div>
                    )
                )}

                {transition(
                  (style, item) =>
                    item === "Images" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <ImagesWrapper key={"Menu6"} />
                      </animated.div>
                    )
                )}

                {transition(
                  (style, item) =>
                    item === "Videos" && (
                      <animated.div
                        style={style}
                        className="transitionItem"
                        key={"Menu1"}
                      >
                        <VideosWrapper key={"Menu7"} />
                      </animated.div>
                    )
                )}

                {editableObject.showPanel && <SettingsMenu></SettingsMenu>}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
export default LeftSubMenu;
